import { render, staticRenderFns } from "./Mannings.vue?vue&type=template&id=1b571a02&scoped=true"
import script from "./Mannings.vue?vue&type=script&lang=js"
export * from "./Mannings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b571a02",
  null
  
)

export default component.exports